<script setup lang="ts">
const { isDesktop } = useDevice();
// Define proper TypeScript interface for testimonial data structure
interface Testimonial {
  img: string;
  title: string;
  url: string
}

// Extract testimonial content to avoid repetition
const testimonialContent = {
    img: "/images/slider-laravel.webp",
    title: "Framework for Web Artisan Laravel",
};

const testimonials = ref<Testimonial[]>([
    {
        img: "/images/slider-laravel.webp",
        title: "Framework for Web Artisan <span class='font-bold text-lg'>Laravel</span>",
        url: "/services/frameworks/laravel-development-services"
    },
    {
        img: "/images/slider-nuxt.webp",
        title: "Progress with progressive <span class='font-bold text-lg'>Vue</span>",
         url: "/services/frameworks/vuejs-development-services"
    },
    {
        img: "/images/slider-shopify.webp",
        title: "Framework for Web Artisan <span class='font-bold text-lg'>Shopify</span>",
        url: "/services/cms-development/shopify-development"
    },
    {
        img: "/images/slider-magento.webp",
        title: "Framework for Web Artisan <span class='font-bold text-lg'>Magento</span>",
         url: "/services/cms-development/magento-development"
    },
    {
        img: "/images/slider-joomla.webp",
        title: "Framework for Web Artisan <span class='font-bold text-lg'>Joomla</span>",
         url: "/services/cms-development/joomla-development"
    },
    {
        img: "/images/slider-node.webp",
        title: "Framework for Web Artisan <span class='font-bold text-lg'>Node.js</span>",
         url: "/services/languages/nodejs-development-services"
    },
    {
        img: "/images/slider-wordpress.webp",
        title: "Framework for Web Artisan <span class='font-bold text-lg'>WordPress</span>",
         url: "/services/cms-development/wordpress-development"
    },

]);

// Use computed properties to handle responsive behavior instead of direct DOM manipulation
const isMobile = ref(false);

// Use throttle/debounce for resize events to prevent performance issues
let resizeTimeout: number | null = null;

// Improve breakpoint definitions with a more descriptive name
const carouselBreakpoints = ref([
  { breakpoint: "1400px", numVisible: 3, numScroll: 1 }, // For extra-large screens
  { breakpoint: "1200px", numVisible: 3, numScroll: 1 }, // For large screens
  { breakpoint: "992px", numVisible: 3, numScroll: 1 }, // For medium screens
  { breakpoint: "768px", numVisible: 2, numScroll: 1 }, // For smaller tablets
  { breakpoint: "576px", numVisible: 1, numScroll: 1 }, // For mobile screens
]);

// Improve the resize handler with debouncing for better performance
function handleResize() {
  if (resizeTimeout) {
    window.clearTimeout(resizeTimeout);
  }

  resizeTimeout = window.setTimeout(() => {
    isMobile.value = window.innerWidth <= 768;
  }, 150); // Debounce by 150ms
}

// Properly handle component lifecycle
onMounted(() => {
  // Set initial state
  isMobile.value = window.innerWidth <= 768;
  // Add event listener with debounced handler
  window.addEventListener("resize", handleResize);
});

// Clean up event listeners to prevent memory leaks
onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
  // Clear any pending timeouts
  if (resizeTimeout) {
    window.clearTimeout(resizeTimeout);
  }
});

// Common styling classes extracted as constants for better maintainability
const carouselItemClasses = "mx-4 h-full c-carousel overflow-hidden relative";
</script>

<template>
  <Carousel
    :value="testimonials"
    :numVisible="4"
    :numScroll="1"
    :showIndicators="!isDesktop"
    :responsiveOptions="carouselBreakpoints"
    :showNavigators="isDesktop"
    :pt="{
      indicatorbutton: {
        class:
          '!rounded-full !size-4 !border !border-[#6727BB] !border-solid !bg-transparent',
      },
    }"
  >
    <template #item="slotProps">
      <NuxtLink :tabindex="!isDesktop ? '0' : '-1' " :class="carouselItemClasses" :to="slotProps.data.url">
        <div class="relative max-w-max mx-auto">
          <NuxtImg
            :src="slotProps.data.img"
            width="263"
            height="345"
            class="mx-auto"
            loading="lazy"
             format="webp"
             :alt="slotProps.data.title"
          />
          <div
            v-html="slotProps.data.title"
            class="tracking-[0.5px] bg-[linear-gradient(180deg,rgba(0,0,0,.65),transparent_40%,transparent)] absolute h-full w-full inset-0 text-white p-5 text-sm"
          ></div>
        </div>
      </NuxtLink>
    </template>
  </Carousel>
</template>
